module.exports = __webpack_public_path__ + "img/video-end.6f35a79c.jpg";